/**
 * Check if notifications are supported
 */
export function areNotificationsSupported(): boolean {
  return 'Notification' in window;
}

/**
 * Get current notification permission
 */
export function getNotificationPermission(): NotificationPermission {
  if (!areNotificationsSupported()) {
    return 'denied';
  }
  return Notification.permission;
}

/**
 * Request notification permission
 */
export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (!areNotificationsSupported()) {
    return 'denied';
  }

  try {
    const permission = await Notification.requestPermission();
    return permission;
  } catch (error) {
    console.error('Failed to request notification permission:', error);
    return 'denied';
  }
}

/**
 * Show notification
 */
export function showNotification(title: string, options?: NotificationOptions): void {
  if (!areNotificationsSupported() || getNotificationPermission() !== 'granted') {
    return;
  }

  try {
    new Notification(title, options);
  } catch (error) {
    console.error('Failed to show notification:', error);
  }
}

/**
 * Show message notification
 */
export function showMessageNotification(content: string, sender: string = 'Bot'): void {
  // Don't show if page is focused
  if (document.hasFocus()) {
    return;
  }

  showNotification(sender, {
    body: content.slice(0, 100), // Limit to 100 chars
    icon: '/icon.png', // Add icon if available
    badge: '/badge.png', // Add badge if available
    tag: 'chat-message', // Replace previous notifications
    requireInteraction: false,
    silent: false,
  });
}
